import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { connect, ConnectedProps } from 'react-redux';
import { toggleAggregation, search } from '../../../state/actions';
import { StateType } from '../../../../state/state.types';
import { CategoryEnum } from '../../../search.types';

const mapState = (
  { aggregations, queryParams }: StateType,
  {
    type,
  }: {
    type: CategoryEnum;
  },
) => ({
  categories: aggregations[type],
  aggregationsPaths: queryParams.aggregationsPaths,
  searchType: queryParams.type,
});

const mapDispatch = (dispatch: ThunkDispatch<StateType, {}, AnyAction>) => ({
  toggleAggregation(path: string[], value: boolean) {
    dispatch(toggleAggregation(path, value));
    dispatch(search({ reason: 'faceted' }));
  },
});

export const Connect = connect(mapState, mapDispatch);

export type PropsFromRedux = ConnectedProps<typeof Connect>;
